import * as React from 'react';

import navbarJson from '../json/navbar';

export interface INavBar {}

export default function NavBar(props: INavBar) {
  return (
    <>
      {navbarJson.data.map((title, index) => {
        return (
          <a
            href={title.href}
            className='hover:text-fr bb-fr mt-5 lg:mt-0 text-xl  lg:pb-5'
          >
            <div className=''>{title.title}</div>
          </a>
        );
      })}
    </>
  );
}
